import React, { useState } from 'react'
import { styled } from '@mui/material/styles';
import { Avatar, Button, CssBaseline, Grid, Container, InputAdornment, LinearProgress, InputLabel, Input } from '@mui/material';
import Alert from '@mui/material/Alert';
import { useDispatch } from 'react-redux';
import { loginUser } from '../redux/ActionCreator';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import config from '../config.json';
import { apiRequest } from '../functions/apiRequest';

const PREFIX = 'LoginPage';

const classes = {
	paper: `${PREFIX}-paper`,
	avatar: `${PREFIX}-avatar`,
	large: `${PREFIX}-large`,
	form: `${PREFIX}-form`
};

const Root = styled('div')((
	{
		theme
	}
) => ({
	[`& .${classes.paper}`]: {
		marginTop: theme.spacing(15),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		backgroundColor: '#ffffff',
		borderRadius: 20,
		height: 553,
		zIndex: 5,

	},

	[`& .${classes.avatar}`]: {
		margin: theme.spacing(1),
		backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.websiteColor,
		height: theme.spacing(12),
		width: theme.spacing(12),
		marginTop: theme.spacing(4),


	},

	[`& .${classes.large}`]: {
		width: theme.spacing(7),
		height: theme.spacing(7),
	},

	[`& .${classes.form}`]: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing(3),
	}
}));

// toast.configure()

function LoginPage() {


	const [isLoading, setisLoading] = useState(false)
	const dispatch = useDispatch()
	const [passwordShown, setPasswordShown] = useState(false);
	const togglePassword = () => {
		// When the handler is invoked
		// inverse the boolean state of passwordShown
		setPasswordShown(!passwordShown);
	};
	const initialFormData = Object.freeze({
		email_id: '',
		password: '',
	});

	const [formData, updateFormData] = useState(initialFormData);
	const errors = ('');
	const [forgotP, setforgotP] = useState(false)
	const handleSubmit = (e) => {
		e.preventDefault();
		//console.log(formData);

		const body = {
			username: formData.email_id.toLowerCase(),
			password: formData.password,
		}

		dispatch(loginUser(body))


	};

	const handleChange = (e) => {
		//console.log(formData)
		updateFormData({
			...formData,
			// Trimming any whitespace
			[e.target.name]: e.target.value.trim(),
		});


	};

	const forgotPassword = async (e) => {
		if (e) e.preventDefault();
		if (!formData.email_id) {
			toast.error('Please enter your account email ID')
			return
		}
		setisLoading(true)
		const response = await apiRequest('POST', JSON.stringify({ 'email_id': formData.email_id.toLowerCase() }), '/password-reset', null, null, {}, true);
		if (response && response.status === 404) {
			toast.error(response.message || 'User not found')
		} else {
			toast.success(response.message || 'Password reset link sent successfully')
		}
		setisLoading(false)
	}



	if (!isLoading) {
		return (
			<Root   >

				<Container component="main" maxWidth="xs" style={{ zIndex: 10 }}>
					<CssBaseline />
					<div className={classes.paper}>
						<Avatar className={classes.avatar}></Avatar>

						{errors.length > 0 ? <Alert severity='error'> {errors}</Alert> : null}
						{!forgotP ?
							<form className={classes.form} noValidate>
								<Grid container spacing={3} style={{ zIndex: 5 }}>
									<Grid item xs={12} style={{ marginLeft: 20, marginRight: 20 }}>
										<InputLabel style={{ textAlign: 'left' }}>Email ID</InputLabel>
										<Input
											variant="outlined"
											required
											fullWidth
											style={{ height: 40 }}
											id="email_id"
											label="Email Address"
											name="email_id"
											autoComplete="email"
											onChange={handleChange}
										/>
									</Grid>


									<Grid item xs={12} style={{ display: 'inline-block', marginLeft: 20, marginRight: 20 }}>
										<InputLabel style={{ textAlign: 'left' }}>Password</InputLabel>
										<Input

											required
											fullWidth
											style={{ height: 40 }}
											name="password"
											label="Password"
											type={passwordShown ? "text" : "password"}
											id="password"
											autoComplete="current-password"
											onChange={handleChange}
											endAdornment={
												<InputAdornment position="end">
													<Button onClick={togglePassword}><span className="material-icons">
														visibility
													</span></Button>
												</InputAdornment>
											}
										/>




									</Grid>
									<br></br>
									<Grid item xs={12} style={{ textAlign: 'center' }}>
										<Button
											type="submit"
											variant="contained"
											style={{ backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor, color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor, height: 40, marginTop: 16 }}
											onClick={handleSubmit}
										>
											Sign In
										</Button>
									</Grid>
									<Grid item xs={12} style={{ textAlign: 'center' }}>
										<Button
											type="submit"
											style={{ height: 20, width: 177, marginTop: 16, fontSize: 15 }}
											color="primary"
											onClick={() => { setforgotP(true) }}

										>
											Forgot Password
										</Button>
									</Grid>
									<Grid item xs={12} style={{ textAlign: 'center' }}>
										<Button
											type="submit"
											fullWidth
											style={{ height: 23, width: 233, marginTop: 48, fontSize: 11 }}
											color="primary"
											href='/signup/offer'
										>
											Don't have an account? Sign up
										</Button>
									</Grid>
								</Grid>
							</form>
							:
							<form className={classes.form} noValidate onSubmit={forgotPassword}>
								<InputLabel style={{ textAlign: 'left' }}>Please enter your account email ID</InputLabel>
								<Input
									variant="outlined"
									required
									fullWidth
									style={{ height: 40, marginBottom: 20 }}
									id="email_id"
									label="Email Address"
									name="email_id"
									autoComplete="email"
									onChange={handleChange}
								/>
								<Grid item xs={12} style={{ textAlign: 'center' }}>
									{/* <Button
										variant="contained"
										style={{ backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor, color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor, height: 40, width: 200, marginTop: 16 }}
										onClick={forgotPassword}
									>
										Send Email
									</Button> */}
									<Button
										type="submit"
										variant="contained"
										style={{ backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor, color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor, height: 40, width: 200, marginTop: 16 }}
									>
										Send Reset Link
									</Button>
									<Button
										type="submit"
										variant="contained"
										style={{ backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor, color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor, height: 40, width: 200, marginTop: 16 }}
										onClick={() => { setforgotP(false) }}
									>
										Go Back
									</Button>
								</Grid>

							</form>
						}
					</div>
				</Container>

			</Root>
		);
	}
	else {
		return (
			<div style={{ marginTop: 20, textAlign: "center" }}>
				<img
					alt={"logo"}
					style={{ height: 350, width: 300 }}
					src={`${process.env.REACT_APP_R2_URL}/general/time_creds_logo.png`}
				/>
				<LinearProgress />
			</div>
		);
	}

}

export default LoginPage